import { cn } from '@/utils/cn';

export function Avatar({ name, src, size = 'md' }: { name: string; src?: string | undefined; size?: 'sm' | 'md' | 'lg' }) {
  const dims = { sm: 'size-8 text-xs', md: 'size-11 text-sm', lg: 'size-20 text-2xl' }[size];
  const initials = name.split(/\s+/).filter(Boolean).slice(0, 2).map((p) => p[0]?.toUpperCase()).join('');
  return src ? (
    <img src={src} alt="" className={cn('shrink-0 rounded-full object-cover', dims)} />
  ) : (
    <span aria-hidden="true" className={cn('inline-flex shrink-0 items-center justify-center rounded-full bg-brand-100 font-semibold text-brand-800', dims)}>
      {initials || '?'}
    </span>
  );
}
